import { routing } from '@/i18n/routing'

export const processLinkHrefAttribute = (href: string, locale: string) => {
  if (routing.localePrefix === 'as-needed' && locale === routing.defaultLocale) {
    return `${href.startsWith('/') ? '' : '/'}${href}`
  }
  return `/${locale}${href.startsWith('/') ? '' : '/'}${href}`
}
